import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import PageError from '../PageError/PageError';

const useStyles = makeStyles()({
    flexWrapper: {
        height: '100%',
    },
});

interface Props {
    showLoading: boolean;
    showError: boolean;
    children: React.ReactElement;
}

export default function PageStatus({ showLoading, showError, children }: Props) {
    const { classes } = useStyles();

    /*
     *  Return null for component when condition is not met rather than using if statement to
     *  change which component is rendered.
     *
     *  This preservs the "position" for each component and prevents React from having to
     *  mount/unmount components in different "positions" based on outcome of condition.
     *
     *  https://medium.com/@cowi4030/optimizing-conditional-rendering-in-react-3fee6b197a20
     *
     *  TIP: showError should always be checked first
     */

    return (
        <>
            {showError && (
                <Grid
                    container
                    direction="column"
                    wrap="nowrap"
                    alignItems="center"
                    justifyContent="center"
                    className={classes.flexWrapper}
                >
                    <Grid item xs="auto">
                        <PageError />
                    </Grid>
                    {showLoading && (
                        <Grid item xs="auto">
                            <CircularProgress color="primary" />
                        </Grid>
                    )}
                </Grid>
            )}
            {showLoading && !showError && (
                <Grid
                    container
                    direction="row"
                    wrap="nowrap"
                    alignItems="center"
                    justifyContent="center"
                    className={classes.flexWrapper}
                >
                    <Grid item xs="auto">
                        <CircularProgress color="primary" />
                    </Grid>
                </Grid>
            )}
            {!showError && !showLoading && <>{children}</>}
        </>
    );
}
